const DinesLogoWithTitle = () => (
  // eslint-disable-next-line @next/next/no-img-element
  <img
    src="/dines-logo-greyscale-tagline.svg"
    alt="Dines"
    width={132}
    height={40}
    className="h-12 w-40 shrink-0 object-contain object-left brightness-0 invert"
  />
);

export default DinesLogoWithTitle;
